/* pmg-menu-anchor.js - Peak Moto
 *
 * Anchors each desktop mega-menu panel under the menu item that opens it.
 *
 * The panel is position:absolute inside .theme__header, so its `left` is in
 * page coordinates, not item coordinates. This writes one number per item -
 * --pmg-dd-left - and custom.css does the rest:
 *
 *     .header__menu__inner .header__dropdown { left: var(--pmg-dd-left, 36px) }
 *
 * The number is the panel's own left padding subtracted from the menu
 * label's left edge, so the first column of links lines up with the label
 * rather than the panel's border sitting under it. It is then clamped: never
 * left of the page gutter, never far enough right that the panel's right edge
 * passes the gutter on the other side. Wide panels (WOMEN'S / MEN'S GEAR are
 * 1300px) therefore stay near the left of the screen because that is the only
 * place they fit; the narrow ones move under their item, which is the whole
 * point of this file.
 *
 * Widths are read with offsetWidth while the panel is still closed. That
 * works because the theme hides it with visibility/opacity, not display, so
 * it is laid out and measurable at all times. If that ever changes to
 * display:none, this file goes quiet and the CSS fallback (36px) takes over.
 */
(function () {
  'use strict';

  var GUTTER = 36;        /* matches the page gutter used in custom.css */
  var MIN_WIDTH = 1100;   /* the breakpoint the mega menu lives behind */

  function headerLeft() {
    var header = document.querySelector('.theme__header');
    return header ? header.getBoundingClientRect().left : 0;
  }

  function placeOne(item, hl, vw) {
    var panel = item.querySelector('.header__dropdown');
    if (!panel) return;

    var width = panel.offsetWidth;
    if (!width) return; /* not laid out - leave the CSS fallback alone */

    var inner = panel.querySelector('.header__dropdown__inner');
    var pad = inner ? parseFloat(getComputedStyle(inner).paddingLeft) || 0 : 0;
    var label = item.querySelector('.navlink--toplevel .navtext') || item;

    var want = label.getBoundingClientRect().left - hl - pad;
    var max = vw - hl - GUTTER - width;
    var left = Math.max(GUTTER, Math.min(want, max));

    panel.style.setProperty('--pmg-dd-left', Math.round(left) + 'px');
  }

  function placeAll() {
    if (window.innerWidth < MIN_WIDTH) return;
    var items = document.querySelectorAll('.header__menu__inner .menu__item');
    if (!items.length) return;
    var hl = headerLeft();
    /* clientWidth, not innerWidth: it excludes the scrollbar, which is real
       estate the panel cannot use. */
    var vw = document.documentElement.clientWidth;
    for (var i = 0; i < items.length; i++) placeOne(items[i], hl, vw);
  }

  var frame = null;
  function schedule() {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      frame = null;
      placeAll();
    });
  }

  /* Re-measure the one item about to open. Cheap, and it covers the cases a
     load/resize pass cannot: a late web font, a lazy promo image, or the
     menu being edited in the theme editor. */
  function onEnter(e) {
    if (window.innerWidth < MIN_WIDTH) return;
    var item = e.target.closest && e.target.closest('.header__menu__inner .menu__item');
    if (item) placeOne(item, headerLeft(), document.documentElement.clientWidth);
  }

  function start() {
    placeAll();
    document.addEventListener('mouseover', onEnter, true);
    document.addEventListener('focusin', onEnter, true);
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
